export const ACTIVATE_USER_REQUEST = "ACTIVATE_USER_REQUEST";
export const DEACTIVATE_USER_REQUEST = "DEACTIVATE_USER_REQUEST";
